import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { LOGO_MARK } from '../lib/brand';
import { passwordError } from './PlatformPasswordFields';

export default function PlatformLogin() {
  const { login, loginWithGoogle } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try { await login(form.email.trim().toLowerCase(), form.password); }
    catch (err) { setError(passwordError(err, 'Sign in failed')); }
    finally { setBusy(false); }
  };
  return (
    <div className="pc-shell pc-login-shell" data-testid="pc-login">
      <form className="pc-login-card" onSubmit={submit} data-testid="pc-login-form">
        <div className="pc-login-brand">
          <img src={LOGO_MARK} alt="" aria-hidden="true" className="pc-login-logo-mark" />
          DutiLyne <small>platform console</small>
        </div>
        <h1 className="pc-h1" data-testid="pc-login-title">Staff sign in</h1>
        <p className="pc-sub">Vendor access for DutiLyne platform staff.</p>
        <label className="pc-login-field">Work email
          <input className="pc-input" type="email" autoComplete="username" required maxLength={254}
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="you@dutilyne.com" data-testid="pc-login-email" />
        </label>
        <label className="pc-login-field">Password
          <input className="pc-input" type="password" autoComplete="current-password" required
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="pc-login-password" />
        </label>
        <Link className="pc-password-link" to="/platform/forgot-password" data-testid="pc-forgot-password-link">Forgot password?</Link>
        {error && <p className="pc-password-error" role="alert" data-testid="pc-login-error">{error}</p>}
        <button type="submit" className="pc-btn pc-btn-primary pc-login-submit" disabled={busy} data-testid="pc-login-submit">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ShieldCheck className="h-3.5 w-3.5" />}
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <button type="button" className="pc-btn pc-login-submit" disabled={busy}
          onClick={() => loginWithGoogle('/platform')} data-testid="pc-login-google">Sign in with Google</button>
        <p className="pc-login-note">Pharmacy teams sign in from the DutiLyne app.</p>
      </form>
    </div>
  );
}